<div class="d-flex" style="vertical-align: middle; align-items: center">
  <div class="avatar-box" *ngIf="hasLogo; else initials">
    <img [src]="provider?.logo" alt="" />
  </div>
  <ng-template #initials>
    <div class="user-card-item">
      <h5 class="m-0">{{ initial }}</h5>
    </div>
  </ng-template>
  <h5>{{ provider?.fname }} {{ provider?.lname }}</h5>
</div>
